import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/tailwind.css'

Vue.config.productionTip = false

Vue.directive('scroll', function(el, binding) {
  const f = function(evt) {
    if (binding.value(evt, el)) {
      window.removeEventListener('scroll', f)
    }
  }
  window.addEventListener('scroll', f)
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
